import Vue from "vue";

export default class{
    
    constructor() {
        this.init()
    }
    init(){
        const _self = this
        const estimate = document.querySelector("#estimate-form")
        const els = {
            q1 : document.querySelector('[type="hidden"][name="radio-question01"]'),
            q2 : document.querySelector('[type="hidden"][name="radio-question_a-01"]'),
            q3 : document.querySelector('[type="hidden"][name="radio-question_a-02"]'),
            q4 : document.querySelector('[type="hidden"][name="radio-question_b-01"]'),
            q5 : document.querySelector('[type="hidden"][name="radio-question_b-02"]'),
            q6 : document.querySelector('[type="hidden"][name="radio-question_b-03"]'),
            q7 : document.querySelector('[type="hidden"][name="radio-question_b-04"]')
        }
        const result = document.querySelector('[type="hidden"][name="radio-result"]')

        if(estimate){
            this.estimate = new Vue({
                el: '#estimate-form',
                data: {
                    q1 : 0,
                    q2 : 0,
                    q3 : 0,
                    q4 : 0,
                    q5 : 0,
                    q6 : 0,
                    q7 : 0,
                    result : "",
                },
                methods :{
                    reset(index){
                        for (let i = 7; i > index; i--) {
                            this['q' + i] = 0 
                        }
                    },
                    set_data(){
                        for (let i = 1; i < 8; i++) {
                            if(this['q' + i] > 0){
                                if(i == 1){
                                    els['q' + i].setAttribute("value",(this['q' + i] == 1) ? "一戸建て（共同住宅以外すべて）" : "共同住宅（マンション・長屋造・アパート等）")
                                }else{
                                    els['q' + i].setAttribute("value",(this['q' + i] == 1) ? "はい" : "いいえ")
                                }
                            }else{
                                els['q' + i].setAttribute("value", "")
                            }
                        }
                        this.$nextTick(()=>{

                            const input_result = document.querySelector('[type="radio"][name="radio-result"]')
                            if(input_result){
                                result.setAttribute('value',input_result.value)
                            }else{

                                result.setAttribute('value',"")
                            }
                        })
                    },
                    get_result(type){
                        if(type == 1){
                            if(this.q1 == 1 && this.q2 == 1){
                                return true
                            }
                            if(this.q1 == 1 && this.q2 == 2  && this.q3 == 1){
                                return true
                            }
                            // q1 2 && q4 2 && q5 2 && q6 1 -> T構造
                            if(this.q1 == 2 && this.q4 == 2  && this.q5 == 2 && this.q6 == 1){
                                return true
                            }
                            // q1 2 && q4 2 && q5 2 && q6 2 && q7 1 -> T構造
                            if(this.q1 == 2 && this.q4 == 2  && this.q5 == 2 && this.q6 == 2 && this.q7 == 1){
                                return true
                            }
                        }
                        if(type == 2){
                            if(this.q1 == 1 && this.q2 == 2  && this.q3 == 2){
                                return true
                            }
                            // q1 2 && q4 2 && q5 2 && q6 2 && q7 2 -> H構造
                            if(this.q1 == 2 && this.q4 == 2  && this.q5 == 2 && this.q6 == 2 && this.q7 == 2){
                                return true
                            }
                        }
                        if(type == 3){
                            if(this.q1 == 2 && this.q4 == 1){
                                return true
                            }
                            if(this.q1 == 2 && this.q4 == 2 && this.q5 == 1){
                                return true
                            }
                        }
                        return false
                    }
                },
                mounted(){
                    for (let i = 1; i < 8; i++) {
                         if(els['q' + i].getAttribute("value")){
                            if(i == 1){
                                
                                if(els['q' + i].getAttribute("value") ==  "一戸建て（共同住宅以外すべて）"){
                                    this['q' + i] = 1
                                }else{
                                    this['q' + i] = 2
                                }
                            }else{
                                    
                                if(els['q' + i].getAttribute("value") == 'はい'){
                                    this['q' + i] = 1
                                }else{
                                    this['q' + i] = 2
                                }
                            }
                         }
                    }
                    this.$nextTick(()=>{

                        const input_result = document.querySelector('[type="radio"][name="radio-result"]')
                        if(input_result){
                            result.setAttribute('value',input_result.value)
                        }else{

                            result.setAttribute('value',"")
                        }
                    })
                    // for (let i = 1; i < 8; i++) {
                    //     if(this['q' + i] > 0){
                    //         els['q' + i].setAttribute("value",(this['q' + i] == 1) ? "はい" : "いいえ")
                    //     }else{
                    //         els['q' + i].setAttribute("value", "")
                    //     }
                    // }
                }
            })
        }

    }
}